import axios from "axios";
import { Dispatch, SetStateAction } from "react";
import { AnyIfEmpty } from "react-redux";
import { GET_VENDOR_FAILURE, GET_VENDOR_REQUEST, GET_VENDOR_SUCCESS } from "../constants/vendors.constants";


const getVendorRequest = () => {
    return {
        type: GET_VENDOR_REQUEST,
    };
};

const getVendorSuccess = (vendorData: AnyIfEmpty<object>) => {
    return {
        type: GET_VENDOR_SUCCESS,
        payload: vendorData,
    };
};

const getVendorFailure = (vendorError: string) => {
    return {
        type: GET_VENDOR_FAILURE,
        payload: vendorError,
    };
};

export const createVendor = (
    vendorObj: object,
    setLoading: Dispatch<SetStateAction<boolean>>,
    onSuccess?: (message: string) => void,
    onFailure?: (message: string, type?: string) => void
) => {
    return () => {
        setLoading(true);

        return axios
            .post('/admin/vendor/create-vendor', vendorObj)
            .then((response) => {
                const status = response?.data?.statusCode;
                const message = response?.data?.message;
                const type = response?.data?.type?.toString()?.toLowerCase();

                if (status === 201) {
                    onSuccess && onSuccess(message);
                } else {
                    onFailure && onFailure(message, type);
                }
            })
            .catch((error) => {
                const message = error?.response?.data?.message || 'Something went wrong';
                onFailure && onFailure(message);
            })
            .finally(() => {
                setLoading(false);
            });
    };
};

export const getVendor = ({ search, page, limit, setTotalCount }: { search?: string, page?: number, limit?: number, setTotalCount?: Dispatch<SetStateAction<number>> }) => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getVendorRequest());
        return axios
            .get(`/admin/vendor/vendors`, {
                params: {
                    searchText: search,
                    page: page,
                    limit: limit
                }
            })
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                    setTotalCount?.(response?.data?.count)
                    dispatch(getVendorSuccess(response.data?.vendors))
                } else {
                    setTotalCount?.(0)
                    dispatch(getVendorFailure(response.data.message))
                }
            }).catch((error) => {
                setTotalCount?.(0);
                dispatch(getVendorFailure(error?.response?.data?.message || 'Something went wrong'));
            });
    }
}

export const editVendor = (id: string, vendorObj: object,
    onSuccess?: (message: string) => void,
    onFailure?: (message: string, type?: string) => void,
    navigate?: AnyIfEmpty<object>) => {
    return () => {
        return axios
            .patch(`/admin/vendor/vendor/${id}`, vendorObj)
            .then((response) => {

                if (response.data.statusCode === 200) {
                    onSuccess && onSuccess(response.data.message)
                    navigate && navigate('/vendor-appointments');
                } else {
                    onFailure && onFailure(response.data.message, response?.data?.type?.toString()?.toLowerCase());
                }
            }).catch((error) => {
                onFailure && onFailure(error.reponse?.data?.message);
            })
    }
}

export const deleteVendor = (id: string, onSuccess?: (message: string) => void, onFailure?: (message: string) => void) => {
    return () => {
        axios.delete(`/admin/vendor/vendor/${id}`)
            .then((response) => {
                if (response.data.statusCode === 200) {
                    onSuccess && onSuccess(response?.data?.message)
                } else {
                    onFailure && onFailure(response?.data?.message)
                }
            }).catch((error) => onFailure && onFailure(error?.response?.data?.message));
    };
};